import styled from "styled-components";
import { buttonThemes } from "../../../atoms/colors";

export const ButtonWrapper = styled.div`
  width: 100%;
  margin-top: 8px;
  a, button {
    width: 100%;
    min-height: 50px;
    height: unset!important;
    ${buttonThemes.primary};
    display: inline-block;
  }
`